<section class="bg-home">
  <div class="bg-overlay"></div>
  <div class="home-center">
    <div class="home-desc-center">
      <div class="container">
        <app-shared-search isOverviewPage="1"></app-shared-search>
      </div>
    </div>
  </div>
</section>
<section class="section overview">
  <div class="container">
    <div class="row back">
      <div class="col-lg-12">
        <a class="back" href="javascript:void(0);" (click)="back()">< Return to Search Results</a>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-8 content-left-desktop">
        <div class="row" *ngIf="isLoading">
          <div class="col-lg-6 skeleton-title">
            <ngx-skeleton-loader
              count="1"
              [theme]="{ 'border-radius': '4px', height: '52px', 'margin-bottom': '0px' }"
            ></ngx-skeleton-loader>
          </div>
          <div class="col-lg-4 skeleton-title"></div>
          <div class="col-lg-2 skeleton-title">
            <ngx-skeleton-loader
              count="1"
              [theme]="{ 'border-radius': '4px', height: '31px', 'margin-bottom': '0px' }"
            ></ngx-skeleton-loader>
          </div>
        </div>
        <div class="row" *ngIf="!isLoading">
          <h5>
            {{ job.title }}
            <app-shared-display-badge [division]="job.division"> </app-shared-display-badge>
          </h5>
          <div class="title">
            <app-shared-display-city-state
              [city]="job.city"
              [state]="job.state"
            ></app-shared-display-city-state>
          </div>
        </div>
        <div class="row">
          <div class="job-description" [innerHTML]="job.description"></div>

          <div class="job-overview-mobile">
            <a
              class="btn-apply btn btn-custom"
              (click)="visibleApplyNowDialog = true"
              href="javascript:void(0);"
              *ngIf="isQuickApplyReady"
              >APPLY FOR THIS JOB</a
            >
            <!-- Remove this when quick-apply api is ready -->
            <a
              class="btn-apply btn btn-mobile btn-custom"
              href="{{ careerURL }}"
              *ngIf="careerURL && !isQuickApplyReady"
              >APPLY FOR THIS JOB</a
            >

            <div class="overview-title">Overview</div>
            <app-shared-job-properties [job]="job"></app-shared-job-properties>
            <hr />
          </div>

          <div class="division-description" [innerHTML]="divisionDescription"></div>

          <div class="keys">
            <h6>Your Keys to Succeeding</h6>
            <div>
              <ul>
                <li>
                  CareerTrak – Application that allows you to view all career opportunities and
                  lanes within C.R. England. Allows you to choose your career path and where you
                  want to go.
                </li>
                <li>
                  CRE Toolbox – Check and respond to your messages while off the truck. Accept your
                  loads, click-to-call your office contacts, view your pay stubs and more!
                </li>
                <li>
                  C.R. England is proudly partnered with CAT Weigh My Truck and Transflo Mobile Plus
                  applications to save time while out on the road.
                </li>
                <li>
                  C.R. England University (CREU) – Safety is one of our top priorities and
                  transportation is ever-changing. With our training courses, you can feel confident
                  while out on the road to ensure you are safe and compliant!
                </li>
                <li>
                  A devoted Driver Manager who is there to support and guide you while out on the
                  road.
                </li>
              </ul>
            </div>
          </div>
          <div class="benefits">
            <h6>Plus ALL the Benefits</h6>
            <div>
              <ul>
                <li>Weekly Pay & Home Time</li>
                <li>Health Benefits & 401k Participation</li>
                <li>Paid Time Off & Bonus Incentives</li>
                <li>Unlimited Cash Referral Program</li>
              </ul>
            </div>
          </div>
          <a
            class="btn-apply btn btn-mobile btn-custom"
            (click)="visibleApplyNowDialog = true"
            href="javascript:void(0);"
            *ngIf="isQuickApplyReady"
            >APPLY FOR THIS JOB</a
          >
          <!-- Remove this when quick-apply api is ready -->
          <a
            class="btn-apply btn btn-mobile btn-custom"
            href="{{ careerURL }}"
            *ngIf="careerURL && !isQuickApplyReady"
            >APPLY FOR THIS JOB</a
          >
        </div>
      </div>
      <div class="col-lg-4 job-overview-desktop">
        <div class="overview-title">Overview</div>
        <app-shared-job-properties [job]="job"></app-shared-job-properties>
        <hr />
        <!-- Remove this when quick-apply api is ready -->
        <a
          class="btn-apply btn btn-custom"
          href="{{ careerURL }}"
          *ngIf="careerURL && !isQuickApplyReady"
          >APPLY FOR THIS JOB</a
        >
        <a
          class="btn-apply btn btn-custom"
          (click)="visibleApplyNowComponent = true"
          href="javascript:void(0);"
          *ngIf="!visibleApplyNowComponent && isQuickApplyReady"
          >APPLY FOR THIS JOB</a
        >
        <app-shared-apply-now-form
          *ngIf="visibleApplyNowComponent"
          [domicileId]="job.domicileId"
          [jobExperience]="job.experience"
          [jobId]="job.jobId"
          [jobTitle]="job.title"
          [recordSource]="recordSource"
          [termsConditionsStyleClass]="'tandc-desktop'"
        ></app-shared-apply-now-form>
      </div>
    </div>
  </div>
</section>
<app-shared-featured-jobs></app-shared-featured-jobs>

<p-dialog
  [baseZIndex]="10000"
  [draggable]="false"
  [closeIcon]="'fal fa-times'"
  #dialDetail
  [modal]="true"
  *ngIf="!isLoading"
  (onShow)="showDialogMaximized(dialDetail)"
  [styleClass]="'apply-now-dialog'"
  [(visible)]="visibleApplyNowDialog"
>
  <p-header> Apply Now</p-header>
  <app-shared-apply-now-form
    [domicileId]="job.domicileId"
    [jobExperience]="job.experience"
    [jobId]="job.jobId"
    [jobTitle]="job.title"
    [recordSource]="recordSource"
    (termsConditionsDialogClose)="onTermsAndConditionsMobileClose()"
    [termsConditionsStyleClass]="'tandc-mobile'"
  ></app-shared-apply-now-form>
</p-dialog>
